// Lightweight global loading debug store
// API: start(id, label, source?), done(id, ok?), fail(id), clearAll(), subscribe(listener)

const listeners = new Set();
let items = []; // [{ id, label, source: 'o365'|'local', status: 'pending'|'ok'|'error', ts }]

function notify() {
	try {
		const snapshot = items.slice();
		for (const fn of Array.from(listeners)) {
			try { fn(snapshot); } catch (_) {}
		}
	} catch (_) {}
}

export function start(id, label, source = 'local') {
	try {
		if (!id) return;
		const existing = items.find(i => i.id === id);
		if (existing) {
			existing.label = label || existing.label;
			existing.source = source || existing.source || 'local';
			existing.status = 'pending';
			existing.ts = Date.now();
		} else {
			items.push({ id, label: String(label || id), source: source || 'local', status: 'pending', ts: Date.now() });
		}
		notify();
	} catch (_) {}
}

export function done(id, ok = true) {
	try {
		const t = items.find(i => i.id === id);
		if (t) {
			t.status = ok ? 'ok' : 'error';
			t.ts = Date.now();
			notify();
		}
	} catch (_) {}
}

export function fail(id) {
	try {
		const t = items.find(i => i.id === id);
		if (t) {
			t.status = 'error';
			t.ts = Date.now();
			notify();
		}
	} catch (_) {}
}

export function clearAll() {
	try {
		items = [];
		notify();
	} catch (_) {}
}

export function subscribe(listener) {
	try {
		if (typeof listener !== 'function') return () => {};
		listeners.add(listener);
		try { listener(items.slice()); } catch (_) {}
		return () => {
			try { listeners.delete(listener); } catch (_) {}
		};
	} catch (_) {
		return () => {};
	}
}

export function hasActive() {
	try { return items.some(i => i.status === 'pending'); } catch (_) { return false; }
}




